package tta.destinigo.talktoastro.feature_chat_consultation_new.domain

import kotlinx.serialization.Serializable

@Serializable
enum class Sender(val value: Int) {
    USER(1),
    EXPERT(0)
}